'use client'
import { AnimatePresence, domAnimation, LazyMotion, m as motion, MotionProps } from 'framer-motion'

import { FC } from 'react'

import { IChildren, IClassName } from '@/app/shared/interfaces/common.interface'

// interface
interface IShowBlock extends IChildren, IClassName, Omit<MotionProps, 'children'> {
  typeTag?: keyof JSX.IntrinsicElements
}

// component
const ShowBlockComponent: FC<Readonly<IShowBlock>> = ({
  children,
  className,
  typeTag,
  ...props
}) => {
  const Component = motion.create(typeTag ?? 'div')

  return (
    <LazyMotion features={domAnimation}>
      <AnimatePresence>
        <Component
          {...props}
          transition={{
            duration: 0.5,
            ...props.transition,
          }}
          viewport={{ once: true, amount: 0.5, ...props.viewport }}
          className={className}
        >
          {children}
        </Component>
      </AnimatePresence>
    </LazyMotion>
  )
}

export default ShowBlockComponent
